<template>
  <div v-if="invoice.documents_public && invoice.documents_public.length > 0">
    <h3 class="page-title title-slash invoice-info-title">
      {{ $t('invoices.single.documents.title') }}
    </h3>
    <table class="table invoice-info-table">
      <tr v-for="document in invoice.documents_public" :key="document.id">
        <td>
          {{ document.tags_value }}
          <small>({{ document.file_size_human }})</small>
        </td>
        <td>
          <a :href="getDownloadUrl(document)" target="_blank">
            <b-icon-download />
          </a>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['invoice'],
  methods: {
    getDownloadUrl(document) {
      return `${process.env.VUE_APP_DRIP_WEB_HOST}/documents/${document.id}/auth/${document.auth_token}`
    }
  }
}
</script>
<style lang="scss">
.remittance-bank {
  font-size: 0.8rem;
}
</style>
